import React, { useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isEmpty from 'lodash/isEmpty';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// CORE COMPONENTS
import CoreDownloadButton from 'core/form/control/types/upload/parts/DownloadButton'; // This is not an exposed component and is inideal

// STYLES
import styles from './reportLink.module.scss';

// MAIN COMPONENT
const ReportLink = ({
  children,
  className,
  href,
  shouldChunkDownload,
  shouldViewFile = true
}) => {

  // MEMOS
  const params = useMemo(
    () => {
      let params = href?.split('viewreport')?.[1]?.split('/')?.filter(child => !!child) || [];
      params = params.reduce((a, v, i) => {
        const index = parseInt(i);
        if (i%2 === 0) a[params[i]] = params[index + 1];
        return a;
      }, {});
      return params
    },
    [href]
  )
  
  // RENDER
  return !isEmpty(params) ? (
    <CoreDownloadButton
      className={clsx(
        className,
        styles.button
      )}
      label={children}
      meta={{ fileName: params.pdfFilename }}
      shouldChunkDownload={shouldChunkDownload}
      shouldViewFile={shouldViewFile}
      viewArgs={{
        endpoint: ENDPOINTS.uploads.sales.viewReport,
        params
      }}
    />
  ) : children;
};

export default ReportLink;
